<template>
  <router-view/>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ModalBus from '../../event-bus/modal-bus';
import SubscriptionCtaPopup from '../../pages/responsive-pages/authenticated/trial/SubscriptionCtaPopup.vue';

export default {
  name: 'PoupupManager',
  props: {
    hideCta: {
      type: Boolean,
      default: false,
    },
  },
  async created() {
    this.startLoading(this.$options.name);
    await this.initSubscriptionState();
    await this.initPromotions();
    this.doneLoading(this.$options.name);

    if (this.shouldShowCta && !this.hideCta) {
      ModalBus.$emit('open', {
        component: SubscriptionCtaPopup,
      });
    }
  },
  computed: {
    ...mapGetters('subscriptionState', ['shouldShowCta']),
  },
  methods: {
    ...mapActions('loader', ['startLoading', 'doneLoading']),
    ...mapActions('subscriptionState', ['initSubscriptionState']),
    ...mapActions('promotions', ['initPromotions']),
  },
};
</script>



// WEBPACK FOOTER //
// src/base-components/app-header/PopupsManager.vue